"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var debugLogger = function debugLogger(message, debugging) {
  if (debugging) {
    console.debug("PKCE Client: ".concat(message));
  }
};

var _default = debugLogger;
exports.default = _default;